import * as React from 'react';
import * as style from './Divider.css';

export const Divider: React.FC = () => {
  return <hr className={style['divider']} />;
};
